module.exports = __webpack_public_path__ + "static/media/3.271226ad.jpg";